import { Header } from '../../components';

const Microsclerotherapy = () => {
    return (
        <div>
            <Header title="Microsclerotherapy" shadow="false" />
            <div className="page-section">
                <div className="container">
                    <div className="max">
                        <section>
                        <div >
                            <br></br>
                                <h2>What is Microsclerotherapy?</h2>
                                <hr></hr>
                                <p className='standardText'>
                                Microsclerotherapy is a popular method of treating superficial telangectasia, also commonly known as thread veins or spider veins on the legs.
                                The thread veins are injected with very tiny needles with a solution called a sclerosing agent. This causes the lining of the vein to break down triggering a healing response which will cause the vein to disappear over time.
                                </p>
                                <p className='standardText'>
                                Alternative forms of management include not treating the thread veins, relief of symptoms from wearing graduated support stockings or where needed surgical intervention.
                                </p>
                                <p className='standardText'>
                                In order to obtain the best results a number of treatment sessions may be required.
                                The number depends on the following factors: extent and nature of the veins, the individual reaction to treatment.
                                </p>
                                <p className='standardText'>
                                Normally between 2 - 6 sessions will be required at 4-12 week intervals.
                                </p>
                                <br></br>
                                <h3>What to expect during the treatment?</h3>
                                <hr></hr>
                                <p className='standardText'>
                                You will have an initial consultation with Dr Hazlehurst to check your suitability for the treatment. It is important to note that if there is an underlying cause of the thread veins or varicose veins these would need to be treated first before Microsclerotherapy, otherwise treatment of the thread veins is likely to be unsuccessful.
                                </p>
                                <p className='standardText'>
                                You will be advised on post procedure compression hosiery.
                                </p>
                                <p className='standardText'>
                                At the treatment appointment your skin will be sterilised and the thread veins on the legs injected with sclerosant.
                                Sometimes a burning sensation is felt during the injections and the skin may develop temporary blebs or wheels.
                                You will wear your compression hosiery to go home in.
                                </p>
                                <br></br>
                                <h3>What to expect after the procedure?</h3>
                                <hr></hr>
                                <p className='standardText'>
                                
                                </p>
                                <p className='standardText'>
                                Following the treatment the area may become red with small dark bruises at the injection sites. The area may be swollen and tender to touch.
                                </p>
                                <p className='standardText'>
                                The area should be kept clean and dry.
                                </p>
                                <p className='standardText'>
                                The treated area often appears worse for approximately 7-10 days post treatment due to the irritation effect of the treatment.
                                </p>
                                <p className='standardText'>
                                It can take 6 - 12 weeks to see the full effects of each treatment session and there is no guarantee that an improvement will be seen.
                                Even after treatment thread veins can reoccur and may require further treatments.
                                </p>
                                <br></br>
                                <h3>What are the possible complications of treatment?</h3>
                                <hr></hr>
                                <p className='standardText'>
                                Very rarely superficial clot formation, bleeding or temporary phlebitis can occur at the treatment site.
                                In very rare cases Deep Vein Thrombosis DVT can occur and would require urgent medical attention.
                                On rare occasions ulcers/ sloughing can form at the injection site. The ulcers are normally very small and heal to leave fine white marks but very rarely they can be larger and take longer periods to heal.
                                On very rare occasions allergic reactions such as skin rash can occur to the injected solutions.
                                Transient hyperpigmentation (brown pigmentation) may occur in the treatment area post treatment. It is nearly always temporary and usually takes a few weeks but can take some months to disappear.
                                </p>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
            </div>
            )
}

export default Microsclerotherapy;